// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { CancellationEventArgsBase, } from "./CancellationEventArgsBase";
export class SpeechRecognitionCanceledEventArgs extends CancellationEventArgsBase {
}

//# sourceMappingURL=SpeechRecognitionCanceledEventArgs.js.map
